/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: 提交按钮组件
 */
import { FC } from 'react';

import styles from './index.module.scss';

interface SubmitButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const SubmitButton: FC<SubmitButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
}) => {
  return (
    <button
      type="button"
      className={`${styles.submitButton} ${disabled ? styles.submitButtonDisabled : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? 'Generating...' : 'Generate'}
    </button>
  );
};

export default SubmitButton;
